import { useState, type FormEvent } from 'react';
import styled from 'styled-components';
import type { ThreadAccountPostReservation } from '../../api/types';
import { reconcileReservation } from '../../api/threadReservation';
import { Field, Input } from '../../shared/components/Field';
import { Button } from '../../shared/components/Button';
import { Alert } from '../../shared/components/feedback';

export function ReservationReconcileForm({ task, onReconciled }: { task: ThreadAccountPostReservation; onReconciled: () => void }) {
  const [postId, setPostId] = useState(task.publishedThreadPostId ?? '');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const submit = async (event: FormEvent) => {
    event.preventDefault();
    if (!postId.trim() || saving) return;
    setSaving(true);
    setError(null);
    try {
      await reconcileReservation(task.id, postId.trim());
      onReconciled();
    } catch (err) { setError(err instanceof Error ? err.message : '게시물을 확인하지 못했습니다.'); }
    finally { setSaving(false); }
  };
  return <RecoveryForm onSubmit={submit}>
    <Field label="이미 발행된 글 연결" htmlFor={`reconcile-${task.id}`}>
      <Input id={`reconcile-${task.id}`} value={postId} onChange={(event) => setPostId(event.target.value)}
        disabled={saving} placeholder="Threads 게시물 숫자 ID" inputMode="numeric"
        aria-describedby={`reconcile-help-${task.id}`} />
    </Field>
    <Help id={`reconcile-help-${task.id}`}>현재 계정의 최근 게시글과 연결해 완료 처리합니다. 새 글은 발행되지 않습니다.</Help>
    {error && <Alert tone="danger">{error}</Alert>}
    <Button type="submit" $size="sm" $variant="secondary" disabled={!postId.trim() || saving}>{saving ? '확인 중…' : '게시된 글 연결'}</Button>
  </RecoveryForm>;
}

const RecoveryForm = styled.form`
  display: grid;
  gap: 10px;
  margin-top: 4px;
  padding: 16px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius.md};
  background: ${({ theme }) => theme.colors.surfaceMuted};
`;
const Help = styled.p`
  margin: 0;
  font-size: 13px;
  line-height: 1.7;
  color: ${({ theme }) => theme.colors.textSecondary};
`;
